module.exports = __webpack_public_path__ + "img/skype.05ba4996.svg";